import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, map, Observable, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-global-search-result',
    templateUrl: './global-search-result.component.html',
    styleUrls: ['./global-search-result.component.sass'],
    standalone: false
})
export class GlobalSearchResultComponent implements OnInit, OnDestroy {
  @Input() results$?: Observable<any[]>;
  @Input() resetCategory$?: Observable<void>;

  aggregateTypes: any[] = [
    {id: 0, name: 'searcher.all', icon: 'all_inclusive'},
    {id: 3, name: 'searcher.organizations', icon: 'corporate_fare'}, 
    {id: 6, name: 'searcher.people', icon: 'group'},
    {id: 4, name: 'searcher.products', icon: 'inventory_2'},
  ];
  filteredResults: any[];

  categoryFilter$: Subject<number>;
  destroy$: Subject<void>;

  constructor() {
    this.filteredResults = [];
    this.destroy$ = new Subject<void>();
    this.categoryFilter$ = new Subject<number>();
  }

  ngOnInit(): void {
    this.resetCategory$?.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.categoryFilter$.next(0);
    });

    combineLatest([
      this.results$!.pipe(map(results => {  // Sort results by aggregate type
        // organizations, contacts, projects, products, documents
        // 3, 6, 9, 12, 15
        // const order = [3, 6, 9, 12, 15]
        // results.sort((a, b) => order.indexOf(a.aggregateTypeId) - order.indexOf(b.aggregateTypeId));
        return results;
      })),
      this.categoryFilter$
    ]).pipe(
      takeUntil(this.destroy$)
    ).subscribe(([r, c]) => {
      this.filteredResults = r.filter(r => {
        return c === 0 || r.aggregateTypeId === c;
      });
    });
    this.categoryFilter$.next(0);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
